export default "__VITE_ASSET__Uw5$5$P6__"